exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".backpane{background-color:#fff}.logo{font-size:64px;font-weight:600;text-align:center}.logo>.now{color:#e50146}.logo>.now,.logo>.yu{font-family:Quicksand}.logo>.yu{color:#37345a}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-me/src/pages/Login.vue"],"names":[],"mappings":"AACA,UACI,qBAAwB,CAE3B,AACD,MACI,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,WAEI,aAAe,CAClB,AACD,qBAHI,qBAAuB,CAM1B,AAHD,UAEI,aAAe,CAClB","file":"Login.vue","sourcesContent":["\n.backpane {\n    background-color: white;\n    /*background-color: #37345a;*/\n}\n.logo {\n    font-size: 64px;\n    font-weight: 600;\n    text-align: center;\n}\n.logo > .now {\n    font-family: Quicksand;\n    color: #e50146;\n}\n.logo > .yu {\n    font-family: Quicksand;\n    color: #37345a;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5caae665","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Login.vue
// module id = 377
// module chunks = 0